import General from '../general/general';

class ProductInfoPreviewSwiper {
    general = new General;
    productInfoSliderEl = $('.product-info__preview-swiper');
    nextBtn = $('.product-info__preview-swiper .swiper-nav-buttons .swiper-button-next');
    prevBtn = $('.product-info__preview-swiper .swiper-nav-buttons .swiper-button-prev');

    productInfoSliderContainer = '.product-info__preview-swiper';
    productInfoSliderOptions = {
        slidesPerView: 1,
        navigation: {
            nextEl: this.nextBtn,
            prevEl: this.prevBtn
        }
    };

    init() {
        if (this.productInfoSliderEl.length > 0) {
            this.swiperInit();
        }
    }

    swiperInit() {
        this.general.initSwiper(this.productInfoSliderContainer, this.productInfoSliderOptions)
    }
}

export default ProductInfoPreviewSwiper;
